import React, { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import * as profileApi from 'api/profile';
import styles from '../style.module.scss';
import { FormControlLabel, Switch } from '@material-ui/core';
import { useDebouncedCallback } from 'use-debounce';

function SettingSwitch({ isOn, nameField, text }) {
  const [isTurnedOn, setTurnedOn] = useState(isOn);
  const queryClient = useQueryClient();

  useEffect(() => {
    setTurnedOn(isOn);
  }, [isOn]);

  const toggleInfoNoti = () => {
    const newSwitchValue = !isTurnedOn;
    setTurnedOn(newSwitchValue);
    sendApi(newSwitchValue);
  };

  const sendApi = useDebouncedCallback(async (value) => {
    const data = {
      [nameField]: String(Number(value)),
    };
    try {
      await profileApi.updateNotification(data);
      queryClient.invalidateQueries('userProfile');
    } catch (e) {
      console.error(e.response?.data?.message);
    }
  }, 500);

  return (
    <div className={styles.infoRow}>
      <span className="font-2">{text}</span>
      <div className={styles.switch}>
        OFF
        <FormControlLabel
          control={
            <Switch
              color="primary"
              checked={!Boolean(isTurnedOn)}
              onChange={toggleInfoNoti}
              classes={{
                checked: styles.checked,
                switchBase: styles.switchBase,
                bar: styles.bar,
              }}
            />
          }
        />
        ON
      </div>
    </div>
  );
}

export default SettingSwitch;
